module.exports = __WEBPACK_EXTERNAL_MODULE_materials_grid_gridMaterial__;